import { render, staticRenderFns } from "./English.vue?vue&type=template&id=72780921&scoped=true"
import script from "./English.vue?vue&type=script&lang=js"
export * from "./English.vue?vue&type=script&lang=js"
import style0 from "./English.vue?vue&type=style&index=0&id=72780921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72780921",
  null
  
)

export default component.exports